import { useBreakpointValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TooltipHeader } from '$/pages/DashboardPages/components/TooltipHeader';

export const SubCollectionColorHeader = () => {
  const { t } = useTranslation();

  const exploreText = useBreakpointValue(
    {
      base: t('dashboard.collection.search.colorTones'),
      md: t('dashboard.collection.exploreColors'),
    },
    { ssr: false },
  );

  return (
    <TooltipHeader
      header={exploreText ?? t('dashboard.collection.filter.collections')}
    />
  );
};
